export const SearchIcon = ({fill, ...props}) => {
    return (
        <>
            <svg
                width={20}
                height={20}
                fill={fill ? fill : '#A7A7A3'}
                {...props}
            >
                <path
                    d="m17.942 17.058-3.201-3.2a7.254 7.254 0 0 0 1.717-4.691c0-4.021-3.27-7.292-7.291-7.292-4.021 0-7.292 3.27-7.292 7.292 0 4.02 3.27 7.291 7.292 7.291a7.254 7.254 0 0 0 4.69-1.717l3.201 3.2a.624.624 0 1 0 .884-.883ZM3.125 9.167a6.048 6.048 0 0 1 6.042-6.042 6.048 6.048 0 0 1 6.041 6.042 6.048 6.048 0 0 1-6.041 6.041 6.048 6.048 0 0 1-6.042-6.041Z"
                />
            </svg>
        </>
    );
}